import { actionTextColor } from "../../utils/themeContrast";
import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { ThemeContext, UserContext } from "../../contexts/Context";
import MenuOptions from "./MenuOptions";
import { navigate } from '@reach/router';
import { IoMdClose } from "react-icons/io";
import AddItemModal from "../AddItemModal";
import axios from "axios";

const Modal = ({
  show,
  setShow,
  recommendedArray,
  setRecommendedArray,
  menuSelectionFormRef,
  addNewItemToCart,
  isCheckout,
  smartRec,
  menuDesign = false
}) => {
  //State
  const displayShow = show ? "flex" : "none";
  const themeContext = React.useContext(ThemeContext);
  const { company, upsellingTitle, cart, token } = React.useContext(UserContext);
  const [recItem, setRecItem] = useState([]);
  const [showRecDialog, setRecItemShow] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [smartContent, setSmartContent] = useState([]);

  const dismissModal = () => {
    setShow(false);
    setRecommendedArray(null);
    if (isCheckout) navigate('/checkout');
  };

  useEffect(() => {
    if (smartRec) {
      axios.post(`/v2/api/selfOrder/recommendation`, {
        cart
      }, {
        headers: { Authorization: "Bearer " + token },
      })
        .then(function (response) {
          // handle success
          setSmartContent([response.data]);
        })
        .catch(function (response) {
       
        });
    }
  }, []);

  const modalContent = (recommendedArray) => {
    if (recommendedArray.length === 0) return;
    return (
      <React.Fragment>
        <MenuOptions
          visibleSlide={1}
          key={recommendedArray[0] ? recommendedArray[0].optionTitle + "recommendedModal" : "recommendedModal"}
          menuIndex={0}
          menuSelectionFormRef={menuSelectionFormRef}
          menuOptions={recommendedArray[0]}
          setRecommendedArray={setRecommendedArray}
          recommendedArray={recommendedArray}
          setPrice={() => { }}
          isSetMeal={true}
          fixedPrice={false}
          hasRecommended={true}
          isModal={true}
          showRecItem={showRecItem}
          addRecItem={addRecItem}
          removeRecItem={removeRecItem}

        />
      </React.Fragment>
    );
  };

  const showRecItem = (item) => {
    setCurrentItem(item);
    setRecItemShow(true);
    let rec = JSON.parse(JSON.stringify(recommendedArray));
    setRecommendedArray(rec);
  };

  const addRecItem = (item) => {
    let its = recItem;
    its.push(item);
    setRecItem(its);
    let rec = JSON.parse(JSON.stringify(recommendedArray));
    setRecommendedArray(rec);
  }
  const handleAddItem = (item) => {
    item.active = true;
    addRecItem(item);
    let rec = JSON.parse(JSON.stringify(recommendedArray));
    for (let it of rec[0].options) {
      if (it.codeId == item.codeId) {
        it.active = true;
        it.qty++;
      }
    }
    setRecommendedArray(rec);
  }

  const removeRecItem = (codeId) => {
    let its = recItem;
    for (let i = its.length - 1; i >= 0; i--) {
      if (its[i].codeId == codeId) {
        its.splice(i, 1);
        setRecItem(its);
        break;
      }
    }

    let rec = JSON.parse(JSON.stringify(recommendedArray));
    setRecommendedArray(rec);
  }

  const modalButton = () => {
    return (
      <ModalButtonContainer menuDesign={menuDesign} themeContext={themeContext}>
        <ModalConfirmButton
          type="button"
          secondary
          themeContext={themeContext}
          onClick={dismissModal}
        >
          <ModalText
            fontSize={16}
            fontWeight={600}
            themeContext={themeContext}
          >
            No Thanks!
          </ModalText>
        </ModalConfirmButton>
        <ModalConfirmButton
          type="button"
          themeContext={themeContext}
          backgroundColor={themeContext.fontPrimary}
          onClick={() => {
            addNewItemToCart(recItem);
            if (isCheckout) navigate('/checkout');
          }}
        >
          <ModalText
            fontSize={16}
            fontWeight={600}
            themeContext={themeContext}

          >
            Add to Cart
          </ModalText>
        </ModalConfirmButton>
      </ModalButtonContainer>
    );
  };

  return (
    <>
      <ModalContainer display={displayShow} menuDesign={menuDesign} onClick={dismissModal}>
        <ModalMain menuDesign={menuDesign} themeContext={themeContext} onClick={(event) => event.stopPropagation()}>
          <ModalTitle menuDesign={menuDesign} themeContext={themeContext}>
            <ModalText
              fontSize={19}
              fontWeight={500}
              themeContext={themeContext}
              color={themeContext.fontPrimary}
              margin={10}
            >
              {upsellingTitle ? upsellingTitle : (company._id == "677ae529d90797dc89c7091a" || company._id == "6805bc98e75fb1ce8570ff56" ? "Try today's special!" : "Would you like any add-ons?")}
            </ModalText>
            <DeleteButton
              type="button"
              aria-label="Close recommendations"
              themeContext={themeContext}
              onClick={dismissModal}
            >
              <IoMdClose size={22} />
            </DeleteButton>
          </ModalTitle>
          {smartRec ?
            <ModalContent menuDesign={menuDesign} themeContext={themeContext}>
              {modalContent(smartContent)}
            </ModalContent>
            :
            <ModalContent menuDesign={menuDesign} themeContext={themeContext}>
              {modalContent(recommendedArray)}
            </ModalContent>
          }
          {modalButton()}
        </ModalMain>
      </ModalContainer>
      <ItemDetailsLayer>
        <AddItemModal
          show={showRecDialog}
          setShow={setRecItemShow}
          item={currentItem}
          handleAddItem={handleAddItem}
        />
      </ItemDetailsLayer>
    </>
  );
};

export default Modal;

// Keep item details and their validation dialogs above the recommendation overlay.
const ItemDetailsLayer = styled.div`
  position: relative;
  z-index: 10001;
`;

const ModalContainer = styled.div`
  display: ${(props) => props.display};
  position: fixed;
  ${(props) => props.menuDesign ? "inset: 0;" : "top: 0;"}
  justify-content: center;
  align-items: flex-end;
  box-sizing: border-box;
  width: 100vw;
  max-width: ${(props) => props.menuDesign ? "none" : "550px"};
  height: 100dvh;
  background: rgba(0, 0, 0, 0.6);
  /* Keep recommendations above member/customer drawers (998/999). */
  z-index: 10000;

  @media (min-width: 768px) {
    inset: 0;
    max-width: none;
    padding: 40px;
    align-items: center;
  }
`;

const ModalMain = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  width: 100%;
  max-width: 550px;
  max-height: calc(100dvh - 16px);
  flex-direction: column;
  border-radius: 14px 14px 0 0;
  overflow: hidden;
  font-size: 20px;
  font-weight: 500;
  font-family: ${(props) => props.themeContext.fontFamily};
  background-color: ${(props) => props.themeContext.backgroundColor};
  color: ${(props) => props.themeContext.fontPrimary};
  z-index: 1000;

  animation: modalRec .2s;
  animation-timing-function: ease-out;
  @keyframes modalRec {
    0%  {
      transform: translateY(350px);
    }
    
    100%  {
      transform: translateY(0px);
    }
  }

  @media (min-width: 768px) {
    position: relative;
    left: auto;
    bottom: auto;
    width: ${(props) => props.menuDesign ? "calc(100vw - 80px)" : "100%"};
    max-width: ${(props) => props.menuDesign ? "1200px" : "550px"};
    max-height: calc(100dvh - 80px);
    border-radius: 16px;
    box-shadow: 0 18px 52px rgba(0, 0, 0, 0.35);

    @keyframes modalRec {
      0% {
        opacity: 0;
        transform: translateY(18px) scale(0.98);
      }
      100% {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
  }
`;

const ModalTitle = styled.div`
  display: flex;
  flex: 0 0 auto;
  padding: 14px 16px;
  align-items: center;
  justify-content: space-between;
  background: ${(props) => props.themeContext.backgroundColor};
  border-bottom: 1px solid ${(props) => props.themeContext.borderColor || "#ddd"};

  @media (min-width: 768px) {
    padding: ${(props) => props.menuDesign ? "18px 24px" : "14px 16px"};
  }
`;
const ModalText = styled.div`
  color: ${(props) => props.color || "inherit"};
  font-size: ${(props) => props.fontSize}px;
  font-weight: ${(props) => props.fontWeight};
  line-height: 30px;
`;
const DeleteButton = styled.button`
  display: grid;
  flex: 0 0 auto;
  padding: 0;
  place-content: center;
  width: 36px;
  height: 36px;
  border: 1px solid ${(props) => props.themeContext.borderColor || "#ddd"};
  border-radius: 50%;
  color: ${(props) => props.themeContext.descriptionColor || props.themeContext.fontPrimary};
  background-color: ${(props) => props.themeContext.backgroundColor};
  cursor: pointer;
`;

const ModalContent = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 16px 10px;
  overflow-x: hidden;
  overflow-y: auto;
  text-align: left;
  overscroll-behavior: contain;

  @media (min-width: 768px) {
    padding: ${(props) => props.menuDesign ? "24px" : "16px 10px"};
  }
`;
const ModalButtonContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  gap: 10px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 12px;
  text-align: center;
  background: ${(props) => props.themeContext ? props.themeContext.backgroundColor : "#fff"};
  border-top: 1px solid #ddd;

  @media (min-width: 768px) {
    gap: ${(props) => props.menuDesign ? "12px" : "10px"};
    padding: ${(props) => props.menuDesign ? "14px 24px 18px" : "10px 12px"};
  }
`;

const ModalConfirmButton = styled.button`
  display: flex;
  flex: 1 1 0;
  min-width: 0;
  height: 48px;
  padding: 0 16px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  border: 1px solid ${(props) => props.themeContext.primaryColor};
  > div { color: inherit; }
  color: ${(props) => props.secondary ? actionTextColor(props.themeContext, props.themeContext.backgroundColor) : actionTextColor(props.themeContext)};
  background-color: ${(props) => props.secondary ? props.themeContext.backgroundColor : props.themeContext.primaryColor};
  text-align: center;
  cursor: pointer;
`;


